import React from 'react';
import fill from 'lodash/fill';
// @ts-expect-error - TS2614 - Module '"@atlaskit/dynamic-table"' has no exported member 'RowType'. Did you mean to use 'import RowType from "@atlaskit/dynamic-table"' instead?
import type { RowType } from '@atlaskit/dynamic-table';
import FieldRenderer from './field-renderer/index.tsx';
import type { Props } from './types.tsx';

const getTableRows = ({ totalIssues, pageSize, rows, page = 1 }: Props): RowType[] => {
	let totalRows: RowType[] = [];
	const totalPages = Math.ceil(totalIssues / pageSize);

	if (!rows || !rows.length) return totalRows;

	const visibleRows = rows.map((row) => {
		const cells = row.map((field, index) => ({
			key: `field-${index}`,
			content: <FieldRenderer {...field} />,
		}));
		return { cells };
	});
	const emptyRow: RowType = { cells: [] };
	const numberOfPreviousRows = (page - 1) * pageSize;
	const numberOfNextRows = Math.max(0, (totalPages - page) * pageSize);
	const previousRows: RowType[] = fill(Array(numberOfPreviousRows), emptyRow);
	const nextRows: RowType[] = fill(Array(numberOfNextRows), emptyRow);
	totalRows = [...previousRows, ...visibleRows, ...nextRows];
	return totalRows;
};

export default getTableRows;
